import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  description?: string;
  action?: { to: string; label: string };
  children?: ReactNode;
};

export default function SectionHeading({ eyebrow, title, description, action, children }: SectionHeadingProps) {
  return (
    <div className="mb-7 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="min-w-0">
        <p className="eyebrow mb-2">{eyebrow}</p>
        <h2 className="text-xl font-semibold text-foreground-950 md:text-2xl">{title}</h2>
        {description && (
          <p className="mt-2 max-w-2xl text-[13px] leading-6 text-foreground-600">{description}</p>
        )}
      </div>
      {action && (
        <Link
          to={action.to}
          className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-[12px] text-foreground-700 transition-colors hover:border-primary-500/60 hover:text-primary-400"
        >
          {action.label}
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      )}
      {children}
    </div>
  );
}